import React from "react";
import { Link } from "react-router-dom";
import logoEU from "../../images/eu-logo.svg";
import izjava from "../../documents/izjava_o_pristupacnosti.pdf";
import upute from '../../documents/upute.pdf'


import "./footer.style.scss";
const Footer = () => (
  <div className="footer">
    
    <div>
      <a className="footer-link" href={upute} without="true" rel="noopener noreferrer" target="_blank">Korisničke upute</a>
      <Link className="footer-link" without="true" to="/privacy-policy-v2">Opći uvjeti</Link>
      <a className="footer-link"  href="mailto:potpis.pecat@rdd.gov.hr">Podrška</a>
      <a className="footer-link" href={izjava} without="true" rel="noopener noreferrer" target="_blank">Izjava o pristupačnosti</a>
      <a className="footer-link" href="tel:0800 0440" without="true" rel="noopener noreferrer">Helpdesk tel. 0800 0440</a>
    </div>
    <div>
     
    </div>
    <img className="footer-logo" src={logoEU} alt=""/>
    <p className="footer-text">Projekt je sufinancirala Europska unija iz Europskog socijalnog fonda.</p>
  </div>
);

export default Footer;
